import React, { useState } from "react";
import './BidAnalyser.css';
const BidAnalyzer = () => {
  const [os, setOs] = useState("Windows");
  const [browser, setBrowser] = useState("Chrome");

  const handleRunAnalyzer = () => {
    // Add logic for running the bid analyzer
    console.log("Running Bid Analyzer with settings:", { os, browser });
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "10px", maxWidth: "700px",margin:'0 20px' }}>
      <h2 className="BidHeading">Campaign: Current Ad</h2>
      <p className="Bidsubheading">Real-time Bid Analyzer</p>
      <p className="Bidpara">
        The real-time bid analyzer will show you the average top bid at this current moment based on your specific campaign targeting.
        <br /> 
        Setting your bid to even 1/10 cent higher than this bid will most likely result in an increase of traffic.
      </p>
      <form className="bidtblheading">
        <div style={{ marginBottom: "10px" ,padding:'8px 0px', border:'solid', borderWidth:'0 0 1px 0', borderColor: '#ededed'}}>
          <label >
            <strong  className="bidtblheading">Traffic Type:</strong>
            <span style={{ marginLeft: "120px" }}>Direct</span>
          </label>
        </div>
        <div style={{ marginBottom: "10px",padding:'8px 0px', border:'solid', borderWidth:'0 0 1px 0', borderColor: '#ededed' }}>
          <label>
            <strong className="bidtblheading">Targeting:</strong>
            <span style={{ marginLeft: "134px" }}>RON (Run Of Network)</span>
          </label>
        </div>
        <div style={{ marginBottom: "10px" ,padding:'8px 0px',border:'solid', borderWidth:'0 0 1px 0', borderColor: '#ededed'}}>
          <label>
            <strong className="bidtblheading">Geo:</strong>
            <span style={{ marginLeft: "164px" }}>United States</span>
          </label>
        </div>
        <div style={{ marginBottom: "10px",padding:'8px 0px', border:'solid', borderWidth:'0 0 1px 0', borderColor: '#ededed' }}>
          <label>
            <strong className="bidtblheading">Choose OS:</strong>
            <select
              value={os}
              onChange={(e) => setOs(e.target.value)}
              style={{ marginLeft: "118px", padding: "5px" }}
            >
              <option value="Windows">Windows</option>
              <option value="MacOS">MacOS</option>
              <option value="Linux">Linux</option>
            </select>
          </label>
        </div>
        <div style={{ marginBottom: "10px",padding:'8px 0px', border:'solid', borderWidth:'0 0 1px 0', borderColor: '#ededed' }}>
          <label>
            <strong className="bidtblheading">Choose Browser:</strong>
            <select
              value={browser}
              onChange={(e) => setBrowser(e.target.value)}
              style={{ marginLeft: "88px", padding: "5px" }}
            >
              <option value="Chrome">Chrome</option>
              <option value="Firefox">Firefox</option>
              <option value="Safari">Safari</option>
              <option value="Edge">Edge</option>
            </select>
          </label>
        </div>
        <button
          type="button"
          onClick={handleRunAnalyzer}
          style={{
            backgroundColor: "#007BFF",
            color: "#FFF",
            border: "none",
            padding: "10px 20px",
            cursor: "pointer",
            borderRadius: "5px",
          }}
        >
          Run Bid Analyzer
        </button>
      </form>
    </div>
  );
};

export default BidAnalyzer;


